export const CUSTOM_QUOTE_MODAL_ACTIONS = {
    SET_MODAL_STARTED: "SET_MODAL_STARTED",
    SET_FORM_COMPLETE: "SET_FORM_COMPLETE",
}